export const DOCUMENT_STATUSES = () => ({ ACTIVE: 'ACTIVE', DISABLED: 'DISABLED' });



// WEBPACK FOOTER //
// ./src/app/merchants/documents/documents.constants.js